import { render, staticRenderFns } from "./RegisterUpload.vue?vue&type=template&id=1e0a804e&scoped=true"
import script from "./RegisterUpload.vue?vue&type=script&lang=js"
export * from "./RegisterUpload.vue?vue&type=script&lang=js"
import style0 from "./RegisterUpload.vue?vue&type=style&index=0&id=1e0a804e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e0a804e",
  null
  
)

export default component.exports